import type { DeckObject, UserData } from "../../constants/GlobalTypesAndEnumsAndConstants";

type MiniReviewUser = Pick<
  UserData,
  "id" | "number_of_sets_of_cards_generated" | "did_user_complete_mini_review_on_first_review"
>;

type MiniReviewDeck = Pick<DeckObject, "user_id" | "duplicate_deck_from_deck_id">;

export function shouldUseMiniReviewForDeck({
  deck,
  user,
  isUserDoingDailyReview = false,
}: {
  deck: MiniReviewDeck | null | undefined;
  user: MiniReviewUser | null | undefined;
  isUserDoingDailyReview?: boolean;
}): boolean {
  if (isUserDoingDailyReview || !deck || deck.duplicate_deck_from_deck_id) {
    return false;
  }

  // A public/shared deck belongs to its creator, not to the new viewer. An
  // ownerless deck is the anonymous generation that the viewer just created.
  if (deck.user_id && deck.user_id !== user?.id) {
    return false;
  }

  if (!user) {
    return !deck.user_id;
  }

  return (
    typeof user.number_of_sets_of_cards_generated === "number" &&
    user.number_of_sets_of_cards_generated <= 1 &&
    !user.did_user_complete_mini_review_on_first_review
  );
}
